@if (eventsService.isLoading$ | async) {
<div class="overlay-loader">
  <div class="logo">
    <img [priority]="true" ngSrc="/assets/images/spinner_logo.svg" alt="overlay-spinner" height="460" width="460" />
  </div>
</div>
}
